const Cryptr = require('cryptr');  
const cryptr = new Cryptr('deeptravel@Map');
export default cryptr;